/**
 * Chart Library section groupings (Catalog page only). Order defines render sequence.
 */
export const CATALOG_LIBRARY_SECTIONS: Array<{ id: string; title: string; chartIds: readonly string[] }> = [
  {
    id: 'health',
    title: 'Core Schedule Health',
    chartIds: ['float_distribution', 'criticality_breakdown', 'quality_issues'],
  },
  {
    id: 'progress',
    title: 'Progress',
    chartIds: ['s_curve_activities', 's_curve_duration', 's_curve_units', 's_curve_wbs', 'wbs_hotspots'],
  },
  {
    id: 'workload',
    title: 'Workload',
    chartIds: ['units_per_day_histogram', 'planned_units_s_curve', 'resource_demand_capacity'],
  },
  {
    id: 'milestones',
    title: 'Milestones',
    chartIds: ['milestone_variance', 'milestone_on_time'],
  },
  {
    id: 'trends',
    title: 'Snapshot Trends',
    chartIds: [
      'critical_path_length',
      'float_trend',
      'near_critical_trend',
      'logic_integrity_trend',
      'phase_progress_burnup',
      'trends_snapshots',
    ],
  },
] as const;

const CHART_TO_SECTION_ID = new Map<string, string>();
for (const section of CATALOG_LIBRARY_SECTIONS) {
  for (const cid of section.chartIds) CHART_TO_SECTION_ID.set(cid, section.id);
}

/** Library-area filter chips (URL `lib=`). Excludes virtual `all`. */
export const CATALOG_LIBRARY_FILTER_GROUPS: Array<{ lib: string; label: string }> = [
  { lib: 'health', label: 'Schedule health' },
  { lib: 'progress', label: 'Progress' },
  { lib: 'workload', label: 'Workload' },
  { lib: 'milestones', label: 'Milestones' },
  { lib: 'trends', label: 'Snapshot trends' },
];

const VALID_LIB = new Set(['all', 'health', 'progress', 'workload', 'milestones', 'trends']);

export function normalizeCatalogLibParam(raw: string | null): string {
  if (raw == null || raw === '' || raw === 'all') return 'all';
  return VALID_LIB.has(raw) ? raw : 'all';
}

export function chartIdsInCatalogLibraryGroup(lib: string): ReadonlySet<string> | null {
  if (lib === 'all') return null;
  const section = CATALOG_LIBRARY_SECTIONS.find((s) => s.id === lib);
  return section ? new Set(section.chartIds) : null;
}

export function catalogSectionIdForChart(chartId: string): string | undefined {
  return CHART_TO_SECTION_ID.get(chartId);
}

export function isCatalogSnapshotTrendChart(chartId: string): boolean {
  return catalogSectionIdForChart(chartId) === 'trends';
}
